export const duplicateNumberForNoAssignee = "000000000000000000000000";
